var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30AB\\u30EC\\u30F3\\u30C0\\u30FC_\\u30A2\\u30A4\\u30B3\\u30F3_\\u9ED2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "24px",
    viewBox: "0 0 126.403 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_522",
    "data-name": "\\u30D1\\u30B9 522",
    d: "M37.386,26.285a7.352,7.352,0,0,0,7.356-7.356h0V7.356a7.356,7.356,0,1,0-14.711,0V18.929a7.352,7.352,0,0,0,7.356,7.356h0Z",
    transform: "translate(-1.306)",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_523",
    "data-name": "\\u30D1\\u30B9 523",
    d: "M94.1,26.285a7.352,7.352,0,0,0,7.356-7.356h0V7.356a7.356,7.356,0,0,0-14.711,0V18.93A7.352,7.352,0,0,0,94.1,26.285h0Z",
    transform: "translate(-3.772 0)",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_524",
    "data-name": "\\u30D1\\u30B9 524",
    d: "M108.689,10.96h-4.553v8.446a13.817,13.817,0,1,1-27.634.01h0V10.96H49.9v8.446a13.822,13.822,0,0,1-27.643,0h0V10.96H17.705A17.711,17.711,0,0,0,0,28.675v84.087a17.713,17.713,0,0,0,17.715,17.715h90.974A17.713,17.713,0,0,0,126.4,112.762V28.675A17.713,17.713,0,0,0,108.689,10.96Zm3.769,98.693a8.205,8.205,0,0,1-8.207,8.207H22.143a8.205,8.205,0,0,1-8.207-8.207V43.864h98.521v65.789Z",
    transform: "translate(0 -0.477)",
    fill: "#464646"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_958",
    "data-name": "\\u9577\\u65B9\\u5F62 958",
    width: 17.973,
    height: 17.973,
    transform: "translate(54.206 85.034)",
    fill: "#464646"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_959",
    "data-name": "\\u9577\\u65B9\\u5F62 959",
    width: 17.973,
    height: 17.973,
    transform: "translate(26.342 85.034)",
    fill: "#464646"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_960",
    "data-name": "\\u9577\\u65B9\\u5F62 960",
    width: 17.982,
    height: 17.973,
    transform: "translate(82.078 57.161)",
    fill: "#464646"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_961",
    "data-name": "\\u9577\\u65B9\\u5F62 961",
    width: 17.982,
    height: 17.973,
    transform: "translate(82.078 85.034)",
    fill: "#464646"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_962",
    "data-name": "\\u9577\\u65B9\\u5F62 962",
    width: 17.973,
    height: 17.973,
    transform: "translate(54.206 57.161)",
    fill: "#464646"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_963",
    "data-name": "\\u9577\\u65B9\\u5F62 963",
    width: 17.973,
    height: 17.973,
    transform: "translate(26.342 57.161)",
    fill: "#464646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIc);
export default __webpack_public_path__ + "static/media/calendar_ic.8bf959c78a677e32e2614c128114ea49.svg";
export { ForwardRef as ReactComponent };